export default __webpack_public_path__ + "static/media/Gautami.b39c54bf.ttf";